
<template>
  <div>
    <template v-if="id === 'feralco'">
      <FeralcoOrdersList :id="id" />
    </template>
    <template v-else-if="id === 'feralcoIntern'">
      <FeralcoInternOrdersList :id="id" />
    </template>
    <template v-else-if="id === 'container'">
      <ContainerOrdersList :id="id" />
    </template>
    <template v-else>
      <StandardOrdersList :id="id" :customer="customer" />
    </template>
  </div>
</template>

<script>

import StandardOrdersList from './StandardOrdersList'
import FeralcoOrdersList from './FeralcoOrdersList'
import FeralcoInternOrdersList from './FeralcoInternOrdersList'
import ContainerOrdersList from './ContainerOrdersList'

export default {
  name: 'OrderListByType',
  props: {
    id: '',
    customer: null
  },
  components: {
    StandardOrdersList,
    FeralcoOrdersList,
    FeralcoInternOrdersList,
    ContainerOrdersList
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Orders/OrderListByType.vue